import { render, staticRenderFns } from "./DPSection.vue?vue&type=template&id=b148d5f2&scoped=true&"
import script from "./DPSection.vue?vue&type=script&lang=js&"
export * from "./DPSection.vue?vue&type=script&lang=js&"
import style0 from "./DPSection.vue?vue&type=style&index=0&id=b148d5f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b148d5f2",
  null
  
)

export default component.exports